import { Schedule } from "@mikros/library";
import { Button } from "@progress/kendo-react-buttons";
import { format } from "date-fns";
import { FormattedMessage, useIntl } from "react-intl";

export interface FinishProps {
  schedule: Schedule;
  postNewSchedule: (schedule: Schedule) => void;
  backStepper: () => void;
}

export function Finish(props: FinishProps) {
  console.log("print every parameter", props.schedule.every);
  const intl = useIntl();
  const monthlyValue = ["FOM", "FMOM", "15OM", "LFOM", "LOM"];
  const monthly = [
    intl.formatMessage({id:"schedule.deliverySchedule.1stOfMonth"}),
    intl.formatMessage({id:"schedule.deliverySchedule.1stMondayOfMonth"}),
    intl.formatMessage({id:"schedule.deliverySchedule.15thOfMonth"}),
    intl.formatMessage({id:"schedule.deliverySchedule.lastFridayOfMonth"}),
    intl.formatMessage({id:"schedule.deliverySchedule.lastDayOfMonth"}),
  ];
  console.log(
    "reminder required option inside finish of schedules",
    props.schedule.isReminderReqrd
  );

  const languageCodeToLanguage: Record<string, string> = {
    en_US:  intl.formatMessage({id:"schedule.course.templateLanguage.English"}),
    ta:  intl.formatMessage({id:"schedule.course.templateLanguage.Tamil"}),
  };

  const isUserRespReqrd = {
    true: intl.formatMessage({id:"schedule.createSchedule.courseOption1"}),
    false:intl.formatMessage({id:"schedule.createSchedule.courseOption2"}),
  };

  const enrolmntType = {
    ALL_COHORT_USER: intl.formatMessage({id:"schedule.createSchedule.cohortEnrolledOption1"}),
    COHORT:
    intl.formatMessage({id:"schedule.createSchedule.cohortEnrolledOption2"}),
    COHORT_USER:
    intl.formatMessage({id:"schedule.createSchedule.cohortEnrolledOption3"}),
  };

  const cohortOption = {
    NEW_USERS_NO:
    intl.formatMessage({id:"schedule.createSchedule.cohortOption1"}),
    NEW_USERS_STRT_FIRST:
    intl.formatMessage({id:"schedule.createSchedule.cohortOption2"}),
  };
  const isSchdlReqrd = {
    true:  intl.formatMessage({id:"schedule.createSchedule.deliveryScheduleTypeOption1"}),
    false:  intl.formatMessage({id:"schedule.createSchedule.deliveryScheduleTypeOption2"}),
  };

  const courseEnd = {
    true: intl.formatMessage({id:"schedule.createSchedule.deliveryScheduleEndOption1"}),
    false: intl.formatMessage({id:"schedule.createSchedule.deliveryScheduleOccurence"}),
  };

  const checkAmPm = (): string => {
    const dt = new Date(props.schedule.startDate);
    if (dt.getHours() >= 12) {
      return " PM";
    }
    return " AM";
  };

  const getWeeklyOn = (): string => {
    let on = props.schedule.on!![0];

    props.schedule.on?.forEach((ele, i) => {
      if (i != 0) {
        on = on + ", " + ele;
      }
    });

    return on;
  };

  const makeFirstCapital = (value: string): string => {
    const firstC = value.at(0);
    let restC = value.slice(1, value.length).toLowerCase();

    const newValue = firstC + restC;

    return newValue;
  };

  const finishNewSchedule = () => {
    let schedule = props.schedule;

    if (props.schedule.frequency.toLowerCase() === "hourly") {
      if (props.schedule.every?.at(0) === "1") {
        if (props.schedule.every?.at(1) !== " ") {
          schedule.every = props.schedule.every.slice(0, 2);
        } else {
          schedule.every = props.schedule.every?.at(0);
        }
      } else {
        schedule.every = props.schedule.every?.at(0);
      }
    } else if (props.schedule.frequency.toLowerCase() === "daily") {
      schedule.every = props.schedule.every?.at(0);
    } else if (props.schedule.frequency.toLowerCase() === "weekly") {
      schedule.every = "";
    } else if (props.schedule.frequency.toLowerCase() === "monthly") {
      const index = monthly.indexOf(props.schedule.every!!);

      schedule.every = monthlyValue[index];
    }

    if (props.schedule.on) {
      schedule.on = props.schedule.on.map((ele) => {
        return ele.slice(0, 3).toUpperCase();
      });
    }

    schedule.startDate = new Date(props.schedule.startDate).toISOString();

    props.postNewSchedule(schedule);
  };

  return (
    <div className="w-full h-full md:text-sm overflow-auto space-y-5">
      <div className="w-full text-mk-very-dark-grey space-y-2">
        <h3 className="font-bold text-base p-2">
          <FormattedMessage id="schedule.createSchedule.finish.courseDetails" />
        </h3>
        <div className="flex flex-col ps-6 gap-2">
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.courseDetails.courseName" />
            </div>
            <div className="">{props.schedule.courseName}</div>
          </div>
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.courseDetails.option" />
            </div>
            <div className="">
              {props.schedule.isUserRespReqrd
                ? isUserRespReqrd.true
                : isUserRespReqrd.false}
            </div>
          </div>
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.courseDetails.welcomeMessage" />
            </div>
            <div className="">{props.schedule.description}</div>
          </div>
        </div>
      </div>

      <div className="w-full space-y-2">
        <h3 className="font-bold text-mk-very-dark-grey text-base p-2">
          <FormattedMessage id="schedule.createSchedule.finish.cohortDetails" />
        </h3>
        <div className="flex flex-col ps-6 gap-2">
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.cohortDetails.cohortName" />
            </div>
            <div className="">{props.schedule.cohortName}</div>
          </div>
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.cohortDetails.enrollement" />
            </div>
            <div className="">
              {props.schedule.enrolmntType === "ALL_COHORT_USER"
                ? enrolmntType.ALL_COHORT_USER
                : props.schedule.enrolmntType === "COHORT"
                ? enrolmntType.COHORT
                : enrolmntType.COHORT_USER}
            </div>
          </div>
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.cohortDetails.options" />
            </div>
            <div className="">
              {props.schedule.isNewUserAllowed === "NEW_USERS_NO"
                ? cohortOption.NEW_USERS_NO
                : props.schedule.isNewUserAllowed === "NEW_USERS_STRT_FIRST"
                ? cohortOption.NEW_USERS_STRT_FIRST
                : cohortOption.NEW_USERS_NO}
            </div>
          </div>
        </div>
      </div>



      <div className="w-full space-y-2">
        <h3 className="font-bold text-mk-very-dark-grey text-base p-2">
          <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails" />
        </h3>
        <div className="flex flex-col ps-6 gap-2">
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.deliverMethod" />
            </div>
            <div className="flex space-x-3">
              {props?.schedule?.channels?.map((channel, index) => (
                <div key={index}>{makeFirstCapital(channel)}</div>
              ))}
            </div>
          </div>
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.deliveryType" />
            </div>
            <div className="">
              {props.schedule.isSchdlReqrd
                ? isSchdlReqrd.true
                : isSchdlReqrd.false}
            </div>
          </div>
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.sDate" />
            </div>

            <div className="">
              {format(new Date(props.schedule.startDate), "dd-MMM-yyyy") +
                " at " +
                 format(
                        new Date(props.schedule.startDate),
                        "hh:mm a"
                      )}
            </div>

            <div>
              {props.schedule.timeZone !== undefined
                ? intl.formatMessage({id:"schedule.createSchedule.deliveryScheduleSelect.tz"})
                : ""}
            </div>
          </div>
          {props.schedule.frequency && (
            <div className="flex pt-1 space-x-2">
              
              <div className="font-bold w-60">
                <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.freq"/>
              </div>
              <div className="">
                {makeFirstCapital(props.schedule.frequency)}
              </div>
            </div>
          )}
          {props.schedule.every &&
          props.schedule.frequency.toLowerCase() !== "weekly" ? (
            <div className="flex space-x-2">
              
              <div className="font-bold w-60">
                <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.on" />
              </div>
              <div className="">{props.schedule.every}</div>
            </div>
          ) : (
            props.schedule.on && (
              <div className="flex space-x-2">
               
                <div className="font-bold w-60">
                  <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.on" />
                </div>
                <div className="">{getWeeklyOn()}</div>
              </div>
            )
          )}
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.cardsPerSchedule" />
            </div>
            <div className="">{props.schedule.cardsPerSchedule}  {" "}
            <FormattedMessage id ="courses.courseCard.cards"/>
            {/* cards */}
            </div>
          </div>
          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.cardsPerChapter" />
            </div>
            <div className="">{props.schedule.assessQuesCnt}  {" "}
            {/* questions */}
            <FormattedMessage id ="schedule.finish.questions"/>
            </div>
          </div>

          {props.schedule.benchmarkScore && (
            <div className="flex space-x-2">
              <div className="font-bold w-60">
                <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.benchMarkScore" />
              </div>
              <div className="">{props.schedule.benchmarkScore}</div>
            </div>
          )}

          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.templateLanguage" />
            </div>
            <div className="">
              {languageCodeToLanguage[props.schedule.languageCode!!]}
            </div>
          </div>

          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.reminderOpition" />
            </div>
            <div className="">
              {props.schedule.isReminderReqrd ? intl.formatMessage({id:"schedule.deliverySchedule.Yes"}) : intl.formatMessage({id:"schedule.deliverySchedule.No"})}
            </div>
          </div>

          <div className="flex space-x-2">
            <div className="font-bold w-60">
              <FormattedMessage id="schedule.createSchedule.finish.scheduleDetails.certificateOption" />
            </div>
            <div className="">
              {props.schedule.certificateReq ? intl.formatMessage({id:"schedule.deliverySchedule.Yes"}) : intl.formatMessage({id:"schedule.deliverySchedule.No"})}
            </div>
          </div>

          {props?.schedule?.endOption?.courseEnd ? (
            <div className="flex space-x-2">
              {/* <div className="font-bold pl-4 w-64">Ends After</div> */}
              <div className="font-bold w-60">
                <FormattedMessage id = "schedule.createSchedule.finish.scheduleDetails.endsAfter"/>
              </div>
              {/* <div className=''>{courseEnd.true}</div> */}
              <div>{courseEnd.true}</div>
            </div>
          ) : (
            <div className="flex space-x-2">
              <div className="font-bold w-60">
                {/* Occurences */}
                <FormattedMessage id = "schedule.createSchedule.finish.scheduleDetails.occurances"/>
                </div>
              <div>{props?.schedule?.endOption?.occurence}</div>
            </div>
          )}


        </div>
      </div>

      <div className="flex justify-end w-full flex-4 space-x-4 pb-[15%] pr-[25%]">
        <Button themeColor={"primary"} onClick={() => props.backStepper()}>
        <FormattedMessage id = "backButton"/>
        </Button>
        <Button themeColor={"primary"} onClick={() => finishNewSchedule()}>
        <FormattedMessage id = "finishButton"/>
        </Button>
      </div>
    </div>
  );
}
